/* eslint-disable import/prefer-default-export */

import { STORY } from 'src/store/ActionTypes';

export const fetchSegments = (query) => ({
  type: STORY.FETCH_SEGMENTS,
  payload: query,
});

export const fetchStories = (query) => ({
  type: STORY.FETCH_STORIES,
  payload: query,
});

export const nextSlide = () => ({
  type: STORY.NEXT_SLIDE,
});

export const prevSlide = () => ({
  type: STORY.PREV_SLIDE,
});
